import React, { useState, useEffect } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { REACT_APP_API_URL } from "../../env";

// const REACT_APP_API_URL = process.env.REACT_APP_API_URL;

const SignupWithOtp = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [emailOtp, setEmailOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [emailOtpSent, setEmailOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [emailOtpVerified, setEmailOtpVerified] = useState(false);
  const [timer, setTimer] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      if (timer > 0) setTimer((prev) => prev - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [timer]);

  const validateEmail = (email) => {
    const allowedDomains = [
      "gmail.com",
      "rediffmail.com",
      "outlook.com",
      "hotmail.com",
      "microsoft.com",
      "yahoo.com",
    ];
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
    if (!emailRegex.test(email.trim())) {
      return false;
    }
    
    const domain = email.trim().split("@")[1].toLowerCase();
    return allowedDomains.includes(domain);
  };

  const validateInputs = () => {
    const isEmailValid = validateEmail(email);
    const isMobileValid = mobile.length === 10;

    if (!isEmailValid) {
      toast.error("Please use a valid email from: Gmail, Rediffmail, Outlook, Hotmail, Microsoft, or Yahoo.");
      return false;
    }

    if (!isMobileValid) {
      toast.error("Enter a valid 10-digit mobile number.");
      return false;
    }

    return true;
  };

  const handleSendOTP = async () => {
    if (!validateInputs()) return;

    const payload = {
      EmailId: email,
      mobileNumber: mobile,
    };

    setIsLoading(true);
    try {
      const res = await axios.post(`${REACT_APP_API_URL}/api/auth/send-otp`, payload);

      if (res.status === 200 && res.data.success) {
        toast.success("OTPs sent to your mobile and email.");
        setOtpSent(true);
        setEmailOtpSent(true);
        setTimer(60);
      } else {
        toast.error(res.data.message || "Failed to send OTPs.");
      }
    } catch (err) {
      if (err.response && err.response.status === 409) {
        toast.error(err.response.data.message || "User already registered.");
      } else {
        toast.error("Error sending OTP");
      }
    }
    setIsLoading(false);
  };

  const handleResendOTP = async () => {
    if (timer > 0) return;

    if (!validateInputs()) return;

    const payload = {
      EmailId: email,
      mobileNumber: mobile,
    };

    setIsLoading(true);
    try {
      const res = await axios.post(`${REACT_APP_API_URL}/api/auth/send-otp`, payload);

      if (res.status === 200 && res.data.success) {
        toast.success("OTP resent successfully");
        setOtp("");
        setEmailOtp("");
        setTimer(60);
      } else {
        toast.error(res.data.message || "Failed to resend OTP.");
      }
    } catch (err) {
      toast.error("Error resending OTP");
    }
    setIsLoading(false);
  };

  const handleVerifyEmailOtp = async () => {
    if (!emailOtp || emailOtp.length !== 4) return toast.error("Enter a valid 4-digit email OTP");
    try {
      const res = await axios.post(`${REACT_APP_API_URL}/api/auth/verifyEmail-otp`, { EmailId: email, otp: emailOtp });
      if (res.data.success) {
        toast.success("Email OTP verified!");
        setEmailOtpVerified(true);
      } else {
        toast.error(res.data.message || "Email OTP verification failed");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Email OTP verification failed");
    }
  };

  const handleVerifyMobileOtp = async () => {
    if (!otp || otp.length !== 4) return toast.error("Enter a valid 4-digit mobile OTP");
    try {
      const res = await axios.post(`${REACT_APP_API_URL}/api/auth/verify-otp`, { mobileNumber: mobile, otp });
      if (res.data.success) {
        toast.success("Mobile OTP verified!");
        setOtpVerified(true);
      } else {
        toast.error(res.data.message || "Mobile OTP verification failed");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Mobile OTP verification failed");
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    if (!emailOtpVerified || !otpVerified) return toast.error("Please verify both OTPs first");
    if (password !== confirmPassword) return toast.error("Passwords do not match");

    try {
      await axios.post(`${REACT_APP_API_URL}/api/auth/register`, {
        EmailId: email,
        Customer_Name: firstName,
        User_Password: password,
        Mobile_Number: mobile,
      });
      toast.success("Registered successfully");
      navigate("/login");
    } catch (error) {
      toast.error(error.response?.data?.message || "Registration error");
    }
  };

  return (
    <div className="signup-background-image d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
      <div className="container" style={{ maxWidth: "400px" }}>
        <form
          className="p-4 rounded text-center"
          style={{ backgroundColor: "rgba(63, 61, 61, 0.7)" }}
          onSubmit={handleRegister}
        >
          <div className="d-flex justify-content-center mb-2">
            <NavLink to="/">
              <img
                src="images/logo/JTDC.png"
                style={{ width: "200px", cursor: "pointer" }}
                alt="Logo"
                loading="lazy"
              />
            </NavLink>
          </div>

          <h5 className="text-white text-center auth-page-title">Sign-up</h5>

          {/* Email Section */}
          <div className="mb-3 text-start" style={{ position: "relative" }}>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter Email"
              required
              className="form-control rounded-pill"
              disabled={emailOtpSent || emailOtpVerified}
              style={{
                cursor: emailOtpSent || emailOtpVerified ? "not-allowed" : "text",
                backgroundColor: emailOtpSent || emailOtpVerified ? "#e9ecef" : "",
                paddingRight: emailOtpVerified ? "40px" : undefined, 
              }}
              title={
                emailOtpSent || emailOtpVerified
                  ? "Email editing disabled after OTP sent"
                  : ""
              }
            />
            {emailOtpVerified && (
              <span
                style={{
                  position: "absolute",
                  right: "15px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#198754",
                  fontSize: "20px",
                  pointerEvents: "none",
                }}
                title="Email Verified"
              >
                &#10004;
              </span>
            )}

            {emailOtpSent && !emailOtpVerified && (
              <div className="form-group mt-2">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Email OTP"
                    value={emailOtp}
                    onChange={(e) => setEmailOtp(e.target.value)}
                    maxLength={6}
                    required
                    style={{
                      borderTopLeftRadius: "50px",
                      borderBottomLeftRadius: "50px",
                      borderTopRightRadius: "0",
                      borderBottomRightRadius: "0",
                    }}
                  />
                  <button
                    type="button"
                    onClick={handleVerifyEmailOtp}
                    className="btn"
                    style={{
                      backgroundColor: "#0d6efd",
                      color: "white",
                      borderTopRightRadius: "50px",
                      borderBottomRightRadius: "50px",
                      borderTopLeftRadius: "0",
                      borderBottomLeftRadius: "0",
                    }}
                  >
                    Verify
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* Mobile Section */}
          <div className="mb-3 text-start" style={{ position: "relative" }}>
            <input
              type="tel"
              value={mobile}
              maxLength={10}
              onChange={(e) => setMobile(e.target.value)}
              placeholder="Enter Mobile No."
              required
              className="form-control rounded-pill"
              disabled={otpSent || otpVerified}
              style={{
                cursor: otpSent || otpVerified ? "not-allowed" : "text",
                backgroundColor: otpSent || otpVerified ? "#e9ecef" : "",
                paddingRight: otpVerified ? "40px" : undefined,
              }}
              title={
                otpSent || otpVerified ? "Mobile editing disabled after OTP sent" : ""
              }
            />
            {otpVerified && (
              <span
                style={{
                  position: "absolute",
                  right: "15px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#198754",
                  fontSize: "20px",
                  pointerEvents: "none",
                }}
                title="Mobile Verified"
              >
                &#10004;
              </span>
            )}

            {otpSent && !otpVerified && (
              <div className="form-group mt-2">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Mobile OTP"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    maxLength={6}
                    required
                    style={{
                      borderTopLeftRadius: "50px",
                      borderBottomLeftRadius: "50px",
                      borderTopRightRadius: "0",
                      borderBottomRightRadius: "0",
                    }}
                  />
                  <button
                    type="button"
                    onClick={handleVerifyMobileOtp}
                    className="btn"
                    style={{
                      backgroundColor: "#0d6efd",
                      color: "white",
                      borderTopRightRadius: "50px",
                      borderBottomRightRadius: "50px",
                      borderTopLeftRadius: "0",
                      borderBottomLeftRadius: "0",
                    }}
                  >
                    Verify
                  </button>
                </div>
              </div>
            )}
          </div>



          {/* Send & Resend OTP */}
          {!otpSent && !emailOtpSent && !otpVerified && !emailOtpVerified && (
            <button
              type="button"
              onClick={handleSendOTP}
              className="btn btn-block"
              style={{ backgroundColor: "#4b9f16", color: "white" }}
            >
              Send OTP
            </button>
          )}
          {(otpSent || emailOtpSent) &&
            !otpVerified &&
            !emailOtpVerified &&
            timer > 0 && (
              <button
                type="button"
                className="btn btn-block mt-5"
                style={{ backgroundColor: "#4b9f16", color: "white" }}
                disabled
              >
                Resend OTP in {timer}s
              </button>
            )}

          {(otpSent || emailOtpSent) &&
            !otpVerified &&
            !emailOtpVerified &&
            timer === 0 && (
              <button
                type="button"
                onClick={handleResendOTP}
                className="btn btn-block mt-5"
                style={{ backgroundColor: "#4b9f16", color: "white" }}
              >
                Resend OTP
              </button>
            )}

          {/* Registration Inputs */}
          {otpVerified && emailOtpVerified && (
            <>
              <input
                type="text"
                className="form-control rounded-pill mb-3"
                placeholder="Enter Full Name"
                value={firstName}
                required
                onChange={(e) => setFirstName(e.target.value)}
              />

              <div className="position-relative mb-3">
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control rounded-pill"
                  placeholder="Enter Password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <span
                  className="position-absolute top-50 end-0 translate-middle-y me-3"
                  style={{ cursor: "pointer" }}
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>

              <div className="position-relative mb-3">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  className="form-control rounded-pill"
                  placeholder="Confirm Password"
                  required
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
                <span
                  className="position-absolute top-50 end-0 translate-middle-y me-3"
                  style={{ cursor: "pointer" }}
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>

              <button
                type="submit"
                className="btn btn-block mt-5"
                style={{ backgroundColor: "#4b9f16", color: "white" }}
              >
                Signup
              </button>
            </>
          )}

          <p className="text-center text-white mt-3">
            Already have an account?{" "}
            <Link
              to="/login"
              style={{
                color: "#ffeb3b",
                textDecoration: "underline",
                fontStyle: "italic",
              }}
            >
              Login
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default SignupWithOtp;